{
  "id": "wheat",
  "name": "Wheat",
  "species": "Triticum aestivum",
  "ploidy": 6,
  "assembly": "IWGSC CS RefSeq v2.1",
  "chromosomes": [
    "Chr1A",
    "Chr1B",
    "Chr1D",
    "Chr2A",
    "Chr2B",
    "Chr2D",
    "Chr3A",
    "Chr3B",
    "Chr3D",
    "Chr4A",
    "Chr4B",
    "Chr4D",
    "Chr5A",
    "Chr5B",
    "Chr5D",
    "Chr6A",
    "Chr6B",
    "Chr6D",
    "Chr7A",
    "Chr7B",
    "Chr7D"
  ],
  "keys": [
    "1A",
    "1B",
    "1D",
    "2A",
    "2B",
    "2D",
    "3A",
    "3B",
    "3D",
    "4A",
    "4B",
    "4D",
    "5A",
    "5B",
    "5D",
    "6A",
    "6B",
    "6D",
    "7A",
    "7B",
    "7D"
  ],
  "pattern": "^(?:chr|chromosome)?[_\\s-]?0*([1-7])[_-]?([ABD])$",
  "sources": [
    "https://ftp.ncbi.nlm.nih.gov/genomes/all/GCF/018/294/505/GCF_018294505.1_IWGSC_CS_RefSeq_v2.1/GCF_018294505.1_IWGSC_CS_RefSeq_v2.1_assembly_report.txt"
  ]
}
